export default __webpack_public_path__ + "static/media/gallery23.e5f772e3.jpg";